/* =========================================================
   Affiche MUSCULATION « Le Duo » — les records à deux.
   API : SNMuscuDuo.render(data, opts) -> string SVG
     data : { title, kicker, season, footer,
              n1, b1 (nom + poids de corps, colonne gauche),
              n2, b2 (colonne droite),
              l1,l2,l3 (libellés des 3 mouvements),
              a1,a2,a3 (charges gauche) , c1,c2,c3 (charges droite) }
     opts : { palette }
   Totaux par personne et total du duo CALCULÉS automatiquement.
   Auto-suffisant (aucune carte) → re-render serveur direct pour l'impression.
   ========================================================= */
(function () {
  const PW = 800, PH = 1066;

  const PALETTES = {
    craie: { label: 'Craie', bg: '#F7F4ED', ink: '#0B2D5B', muted: '#8B94A3', accent: '#FF6B2C', line: '#E3DDD0', box: '#0B2D5B', boxInk: '#F7F4ED', boxMuted: '#93A1B8' },
    nuit:  { label: 'Nuit',  bg: '#0B2D5B', ink: '#F7F4ED', muted: '#93A1B8', accent: '#FF6B2C', line: '#1E4272', box: '#12355F', boxInk: '#F7F4ED', boxMuted: '#93A1B8' },
    fonte: { label: 'Fonte', bg: '#15191F', ink: '#F5F2EA', muted: '#8A93A0', accent: '#FF6B2C', line: '#272D36', box: '#1D232B', boxInk: '#F5F2EA', boxMuted: '#8A93A0' },
    acier: { label: 'Acier', bg: '#E7E9EC', ink: '#14243B', muted: '#77808F', accent: '#FF6B2C', line: '#D3D7DD', box: '#14243B', boxInk: '#F7F4ED', boxMuted: '#93A1B8' },
  };

  const esc = s => String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  const up = s => String(s == null ? '' : s).toUpperCase();
  const num = s => { const m = String(s == null ? '' : s).replace(',', '.').match(/-?\d+(\.\d+)?/); return m ? parseFloat(m[0]) : null; };
  const fmt = n => (Math.round(n * 100) / 100).toFixed(2).replace(/\.?0+$/, '').replace('.', ',');
  const fitSize = (text, maxW, maxSize, cwf, ls, minSize) => {
    const n = String(text).length || 1; minSize = minSize || 12;
    for (let s = maxSize; s > minSize; s -= 1) if (n * (cwf * s + ls) <= maxW) return s;
    return minSize;
  };

  function render(data, opts) {
    data = data || {}; opts = opts || {};
    const p = PALETTES[opts.palette] || PALETTES.craie;
    const cx = PW / 2;

    const labels = [up(data.l1) || 'SQUAT', up(data.l2) || 'DÉVELOPPÉ COUCHÉ', up(data.l3) || 'SOULEVÉ DE TERRE'];
    const cols = [
      { cx: 216, name: up(data.n1) || 'PRÉNOM 1', bw: up(data.b1), vals: [data.a1, data.a2, data.a3] },
      { cx: 584, name: up(data.n2) || 'PRÉNOM 2', bw: up(data.b2), vals: [data.c1, data.c2, data.c3] },
    ];

    const title = up(data.title) || 'NOS RECORDS';
    // max 74 + baseline 184 : la boîte d'ascente Oswald (≈1,2×) reste à ≥10 px
    // sous le sur-titre (baseline 78) — accents É compris.
    const titleSize = fitSize(title, 700, 74, 0.54, 3, 34);
    const kicker = up(data.kicker) || `${cols[0].name} & ${cols[1].name}`;
    const kickerLs = kicker.length > 34 ? 2 : kicker.length > 26 ? 3 : 4.5;
    const kickerSize = fitSize(kicker, 690, 19, 0.58, kickerLs, 12);
    const sub = up(data.season);

    let body = '';
    let grand = 0, grandOk = false;
    for (const c of cols) {
      const nameSize = c.name.length > 12 ? 34 : c.name.length > 9 ? 42 : 50;
      body += `<text x="${c.cx}" y="380" font-family="Oswald" font-size="${nameSize}" font-weight="700" fill="${p.ink}" text-anchor="middle" letter-spacing="2">${esc(c.name)}</text>`;
      if (c.bw) body += `<text x="${c.cx}" y="410" font-size="16" font-weight="600" fill="${p.muted}" text-anchor="middle" letter-spacing="2.5">${esc(c.bw)}</text>`;
      let y = 466, sum = 0, ok = false;
      c.vals.forEach((v, i) => {
        const lab = labels[i];
        const labSize = lab.length > 18 ? 14 : lab.length > 14 ? 16 : 17;
        const n = num(v);
        if (n != null) { sum += n; ok = true; }
        body += `<text x="${c.cx}" y="${y}" font-size="${labSize}" font-weight="600" fill="${p.muted}" text-anchor="middle" letter-spacing="1.5">${esc(lab)}</text>`
          + `<text x="${c.cx}" y="${y + 52}" text-anchor="middle" font-family="Oswald" font-weight="700" fill="${p.ink}">`
          + `<tspan font-size="52">${esc(String(v || '').trim() || '—')}</tspan><tspan font-size="22" fill="${p.accent}" dx="4">KG</tspan></text>`;
        y += 104;
      });
      body += `<line x1="${c.cx - 92}" y1="${y - 30}" x2="${c.cx + 92}" y2="${y - 30}" stroke="${p.line}" stroke-width="1.5"/>`
        + `<text x="${c.cx}" y="${y + 2}" font-size="15" font-weight="700" fill="${p.accent}" text-anchor="middle" letter-spacing="4.5">TOTAL</text>`
        + `<text x="${c.cx}" y="${y + 64}" text-anchor="middle" font-family="Oswald" font-weight="700" fill="${p.ink}">`
        + `<tspan font-size="58">${ok ? fmt(sum) : '—'}</tspan><tspan font-size="24" fill="${p.accent}" dx="5">KG</tspan></text>`;
      if (ok) { grand += sum; grandOk = true; }
    }

    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${PW} ${PH}" font-family="'Sora','Inter',sans-serif">
<rect width="${PW}" height="${PH}" fill="${p.bg}"/>
<text x="${cx}" y="78" font-size="${kickerSize}" font-weight="700" fill="${p.accent}" text-anchor="middle" letter-spacing="${kickerLs}">${esc(kicker)}</text>
<text x="${cx}" y="184" font-family="Oswald" font-size="${titleSize}" font-weight="700" fill="${p.ink}" text-anchor="middle" letter-spacing="3">${esc(title)}</text>
${sub ? `<text x="${cx}" y="212" font-size="17" font-weight="600" fill="${p.muted}" text-anchor="middle" letter-spacing="4">${esc(sub)}</text>` : ''}
<line x1="${cx}" y1="310" x2="${cx}" y2="856" stroke="${p.line}" stroke-width="1.5"/>
<circle cx="${cx}" cy="583" r="42" fill="${p.bg}" stroke="${p.line}" stroke-width="1.5"/>
<text x="${cx}" y="604" font-family="Oswald" font-size="60" font-weight="700" fill="${p.accent}" text-anchor="middle">&amp;</text>
${body}
<rect x="54" y="890" width="${PW - 108}" height="118" rx="16" fill="${p.box}"/>
<text x="${cx}" y="922" font-size="16" font-weight="700" fill="${p.accent}" text-anchor="middle" letter-spacing="7">TOTAL DU DUO</text>
<text x="${cx}" y="996" text-anchor="middle" font-family="Oswald" font-weight="700" fill="${p.boxInk}"><tspan font-size="64">${grandOk ? fmt(grand) : '—'}</tspan><tspan font-size="27" fill="${p.accent}" dx="6">KG</tspan></text>
<text x="${cx}" y="1042" font-size="15" font-weight="600" fill="${p.muted}" text-anchor="middle" letter-spacing="5">${esc(up(data.footer) || 'PLUS FORTS À DEUX')}</text>
</svg>`;
  }

  window.SNMuscuDuo = { render, PALETTES };
})();
